<template>
  <div class="receive">
    <el-dialog :visible.sync="dialogVisible" width="426px" :show-close="false" :before-close="onbalck" :modal-append-to-body="false">
      <div slot="title" class="alertHeader dialogHeader">
        <img loading="lazy" class="dialogClose-header-img cursorPoint" v-lazy="require('../../static/image/pn/login-close2.png')" @click="onbalck" />
        <div class="alertTitle dialogTitles" style="text-align:center">{{signIn.Checkin}}</div>
      </div>
      <div style="text-align: center;">
        <p class="money">{{money}}元</p>
        <p class="verityCount">{{signIn.requirements}}{{verityCount}}{{signIn.bei}}</p>

        <div class="btn-box">
          <el-button class="themeBtnBorder tradingDefaultButtons btncan" @click="onCanale">{{signIn.cancel}}</el-button>
          <el-button class="themeBtn headerButtonRight btn" @click="onReceive">{{signIn.gitNow}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      money: "",
      verityCount: ""
    };
  },
  computed: {
    signIn() {
      return this.$t('signIn')
    }
  },
  methods: {
    onCanale() {
      this.onbalck();
    },
    onReceive() {
      this.$emit("onSignin")
      this.onbalck();
    },
    onbalck() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" >
// @import "./eldialog.scss";

.themeBtn {
  background-color: #e5414a !important;
  background-color: var(--themeColor);
}
.receive {
  .money {
    font-size: 0.42rem;
    color: #2d2b4d;
  }
  .verityCount {
    color: #2d2b4d;
    font-size: 0.14rem;
    margin-top: 0.05rem;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    .btn {
      // flex-grow: 1;
      width: 50%;
      border-radius: 20px;
      color: #fff;
      border: none;
    }
    .btncan {
      width: 50%;
      border-radius: 20px;
    }
    .btncan:hover {
      background: #fff;
    }
    .btn:hover {
      background: var(--ButtonAction);
    }
  }
}
</style>